import PropTypes from 'prop-types'

import Header from './header'
import Body from './body'
import Breadcrumb from './breadcrumb'

const Detail = ({ resource, ...attrs }) => {
  return <>
    <Header
      resource={resource} />
    <Body
      resource={resource} />
    <Breadcrumb
      resource={resource} />
  </>
}

Detail.propTypes = {
  resource: PropTypes.object
}

export default Detail
